import BordStatus from 'components/NudosComponents/BordStatus/BordStatus';
import { DTOgetOrderDetailedData, ORDER_STATUS } from 'types/orders';
import { getCurrentStatusDisplay } from '../OrderLastUpdate/OrderLastUpdate';

interface IOrderDetailStatus {
  orderData?: DTOgetOrderDetailedData;
}

export const OrderDetailStatus = ({ orderData }: IOrderDetailStatus) => {
  const statusDisplay = getCurrentStatusDisplay(orderData?.statusName as ORDER_STATUS);

  return <BordStatus variant={statusDisplay?.variant} label={statusDisplay?.label} />;
};
